// hooks/useRecordRequestHook.ts
import { useState } from 'react';
import { useCreateRecordingRequestMutation } from '../Services/recordingRequestApi';
import { RecordingRequestStatus } from '../models/recordingRequest.model';
import { Meeting } from '../models/meeting.model';

export const useRecordRequestHook = () => {
  const [createRecordingRequest] = useCreateRecordingRequestMutation();
  const [serverError, setServerError] = useState<string | null>(null);

  const sendRequest = async (meeting: Meeting) => {
    setServerError(null);
    try {
      const payload = {
        meeting,
        RecordingRequestStatus: RecordingRequestStatus.Open,
      };

      const response = await createRecordingRequest(payload).unwrap();
      return { success: true, data: response };
    } catch (err: any) {
      console.error('Failed to create recording request:', err);
      setServerError(err?.data?.message || 'Unknown error');
      return { success: false, error: err };
    }
  };

  return { sendRequest, serverError };
};
